  import { createContext } from 'react';

  export interface EvPortsContextProps {
    onSelect?: (ids: string[]) => void;
    onSort?: (field: string, order: "desc" | "asc") => void;
    onEdit?: (evPort: Api.EvPortDto) => void;
    onCreate?: (formData: Api.EvPortDto) => void;
    onUpdateItem?: (evPort: Api.EvPortDto) => void;
    onUpdate?: (id: string, formData: Api.UpdateEvPort) => Promise<void>;
    onDelete?: (evPort: Api.EvPortDto) => Promise<void>;
    onDeleteMany?: (ids: string[]) => Promise<void>;
  }

  /**
   * @memberof EvPorts
   * @component
   * @desc React context for providing methods of evPorts to child components.
   * @property {Function} onSelect - callback for update selected EvPorts or mass delete;
   * @property {Function} onEdit - callback for open the Edit EvPort dialog. (evPort: Api.EvPortDto) => void
   * @property {Function} onUpdate - callback for update an EvPort. (id: string, formData: Api.UpdateEvPort) => Promise<void>
   * @property {Function} onDelete - callback for delete an EvPort. (evPort: Api.EvPortDto) => Promise<void>
   */

  const EvPortsContext = createContext<EvPortsContextProps>({});

  export default EvPortsContext;
